import React, { useState } from 'react';
import Logo from '../../../assets/logo.png';
import { observer } from 'mobx-react-lite';
import globalSettingsBranches from '../../../stores/global-settings-branches';
import globalConfigStore from '../../../stores/global-config-store';
import { Dropdown } from 'primereact/dropdown';
import { Link } from 'react-router-dom';
import { SideBarUserProfile } from './components/side-bar-user-profile';

const SideBarAdministration: React.FC = () => {
  const [expanded1, setExpanded1] = useState<boolean>(false);
  const [expanded2, setExpanded2] = useState<boolean>(false);
  const [expandedReports, setExpandedReports] = useState<boolean>(false);
  const [expandedStudiesReports, setExpandedStudiesReports] =
    useState<boolean>(false);
  const [expandedFinanceReports, setExpandedFinanceReports] =
    useState<boolean>(false);
  const [expandedAccountingReports, setExpandedAccountingReports] =
    useState<boolean>(false);
  const [expandedSettings, setExpandedSettings] = useState<boolean>(false);
  const [expandedUsers, setExpandedUsers] = useState<boolean>(false);
  const [expandedAccounting, setExpandedAccounting] = useState<boolean>(false);
  const [expandedPayments, setExpandedPayments] = useState<boolean>(false);

  // Add years array for the current decade
  const currentYear = new Date().getFullYear();
  const years = Array.from(new Array(5), (val, index) => currentYear + index);

  const handleBranchChange = (branchId: number) => {
    const selectedBranch = globalSettingsBranches.branches.find(
      (b) => b.id === branchId,
    );
    if (selectedBranch) {
      globalConfigStore.rootFilter.currentBranches = selectedBranch;
    }
  };

  const handleYearChange = (year: number) => {
    // TODO: Implement year change logic when the API is available
    console.log('Selected year:', year);
  };

  const createRipple = (event: React.MouseEvent<HTMLDivElement>) => {
    const button = event.currentTarget;
    const ripple = document.createElement('span');
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;

    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    ripple.classList.add('ripple');

    const existingRipple = button.getElementsByClassName('ripple')[0];
    if (existingRipple) {
      existingRipple.remove();
    }

    button.appendChild(ripple);

    ripple.addEventListener('animationend', () => {
      ripple.remove();
    });
  };

  const ExpandableSection = ({
    expanded,

    setExpanded,
    title,
    children,
  }: {
    expanded: boolean;
    setExpanded: (value: boolean) => void;
    title: string;
    children?: React.ReactNode;
  }) => (
    <div className="expandable">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '45px',
          width: '100%',
          padding: '0 16px',
          cursor: 'pointer',
        }}
        className="expandable-header"
        onClick={() => setExpanded(!expanded)}
      >
        <span
          style={{
            color: 'var(--surface-600)',
            display: 'flex',
            alignItems: 'center',
            height: '100%',
          }}
        >
          {title}
        </span>
        <div style={{ flex: 1 }} />

        <i
          className="pi pi-chevron-down"
          style={{
            transform: expanded ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            color: 'var(--surface-600)',
            fontSize: '0.8rem',
          }}
        />
      </div>
      <div
        className="expandable-content"
        style={{
          maxHeight: expanded ? '1000px' : '0',
          opacity: expanded ? '1' : '0',
          overflow: 'hidden',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          transform: `translateY(${expanded ? '0' : '-10px'})`,
        }}
      >
        {children}
      </div>
    </div>
  );

  const ExpandableItem = ({
    expanded,
    setExpanded,
    label,
    icon,
    items,
    category,
  }: {
    expanded: boolean;
    setExpanded: (value: boolean) => void;
    label: string;
    icon: string;
    items: Array<{ icon: string; label: string; route: string }>;
    category: string;
  }) => (
    <div>
      <div className="menu-item" onClick={() => setExpanded(!expanded)}>
        <i className={`pi ${icon}`} style={{ marginLeft: '0.5rem' }}></i>
        <span>{label}</span>
        <div style={{ flex: 1 }} />
        <i
          className="pi pi-chevron-down"
          style={{
            transform: expanded ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            color: 'var(--surface-600)',
            fontSize: '0.8rem',
          }}
        />
      </div>
      <div
        className="expandable-content"
        style={{
          maxHeight: expanded ? `${items.length * 45}px` : '0',
          opacity: expanded ? '1' : '0',
          overflow: 'hidden',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          transform: `translateY(${expanded ? '0' : '-10px'})`,
        }}
      >
        <div className="menu-items">
          {items.map((item, index) => (
            <Link
              key={index}
              to={item.route}
              style={{
                textDecoration: 'none',
                color: 'inherit',
                width: '100%',
              }}
            >
              <div
                className="menu-item sub-item"
                data-category={category}
                onClick={createRipple}
                style={{
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  opacity: expanded ? '1' : '0',
                  transform: `translateX(${expanded ? '0' : '-10px'})`,
                  transitionDelay: `${index * 0.05}s`,
                }}
              >
                <i
                  className={`pi ${item.icon}`}
                  style={{ marginLeft: '0.5rem' }}
                ></i>
                <span>{item.label}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );

  const studiesItems = [
    { icon: 'pi-book', label: 'תוכניות לימודים', route: '/programs' },
    { icon: 'pi-list', label: 'קורסים', route: '/courses-list' },
    { icon: 'pi-calendar', label: 'מפגשים', route: '/education/lectures' },
    {
      icon: 'pi-file-edit',
      label: 'מבחנים חיצוניים',
      route: '/external-exams',
    },
  ];

  const paymentItems = [
    {
      icon: 'pi-credit-card',
      label: 'שירותי תשלום',
      route: '/payment-services',
    },
  ];

  const studiesReportsItems = [
    {
      icon: 'pi-calendar-times',
      label: 'נוכחות כללית',
      route: '/reports/education/attendance',
    },
    {
      icon: 'pi-users',
      label: 'דוח נושרים',
      route: '/reports/education/dropout',
    },
    { icon: 'pi-file', label: 'מבחנים', route: '/reports/education/exams' },
    {
      icon: 'pi-check-square',
      label: 'מטלות',
      route: '/reports/education/assignments',
    },
    {
      icon: 'pi-calendar',
      label: 'מפגשים חורגים',
      route: '/reports/education/lectures',
    },
    {
      icon: 'pi-chart-bar',
      label: 'סטטוס סטודנטים בקורס',
      route: '/reports/education/students-course-status',
    },
    {
      icon: 'pi-comments',
      label: 'משובי הוראה',
      route: '/reports/education/teaching-feedback',
    },
  ];

  const financeReportsItems = [
    {
      icon: 'pi-clock',
      label: 'חריגת שעות הוראה בקורסים',
      route: '/reports/finance/courses-exceeding-hours',
    },
    {
      icon: 'pi-calendar-plus',
      label: 'עלות ומשך קורס בשלוחות',
      route: '/reports/finance/courses-duration-expanded',
    },
    {
      icon: 'pi-building',
      label: 'ניצול נכסי נדלן',
      route: '/reports/finance/real-estate-comparison',
    },
    {
      icon: 'pi-money-bill',
      label: 'שכר לימוד',
      route: '/reports/finance/students-financial',
    },
    {
      icon: 'pi-chart-line',
      label: 'פירוט פיננסי של קורסים לפי שלוחה',
      route: '/reports/finance/course-financial-branch-breakdown',
    },
    {
      icon: 'pi-exchange',
      label: 'השוואה פיננסית בין תוכניות',
      route: '/reports/finance/program-revenue-between-branches',
    },
    /*    {
      icon: 'pi-file-o',
      label: 'דוח אלמנטרי',
      route: '/reports/finance/elementary',
    },*/
  ];

  const accountingReportsItems = [
    {
      icon: 'pi-wallet',
      label: 'תשלומי שכ"ל – כללי',
      route: '/reports/tuition-payments',
    },
    { icon: 'pi-ticket', label: 'שיקים', route: '/reports/checks' },
    {
      icon: 'pi-credit-card',
      label: 'הוראות קבע באשראי',
      route: '/reports/standing-orders',
    },
    {
      icon: 'pi-sync',
      label: 'הוראות קבע בנקאיות',
      route: '/reports/bank-transfer-installments',
    },
  ];

  const accountingItems = [
    {
      icon: 'pi-money-bill',
      label: 'מחולל משכורות',
      route: '/accounting/salaries',
    },
    {
      icon: 'pi-history',
      label: 'היסטוריית משכורות',
      route: '/accounting/salaries/history',
    },
  ];

  const settingsItems = [
    { icon: 'pi-book', label: 'לימודים', route: '/settings/studies' },
    { icon: 'pi-users', label: 'מרצים', route: '/settings/lectures' },
    { icon: 'pi-cog', label: 'שרותים', route: '/settings/operation' },
    { icon: 'pi-file', label: 'מסמכים', route: '/settings/docs' },
    { icon: 'pi-calendar', label: 'שנות עבודה', route: '/settings/times' },
    {
      icon: 'pi-building',
      label: 'כיתות ושלוחות',
      route: '/settings/branch-and-classes',
    },
    {
      icon: 'pi-comments',
      label: 'משובים למרצים',
      route: '/settings/professor-feedback',
    },
  ];

  const usersItems = [
    { icon: 'pi-graduation-cap', label: 'סטודנטים', route: '/students' },
    { icon: 'pi-user-edit', label: 'מרצים', route: '/lecturers' },
    { icon: 'pi-users', label: 'מנהלה', route: '/administration' },
  ];

  return (
    <div
      style={{
        width: '254px',
        marginLeft: '16px',
        minWidth: '254px',
        maxWidth: '254px',
        direction: 'rtl',
        height: '100vh',
        backgroundColor: '#ffffff',
        position: 'sticky',
        top: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '1px 0 2px rgba(0, 0, 0, 0.05)',
        zIndex: 1000,
        borderLeft: '1px solid var(--surface-200)',
      }}
    >
      <div
        style={{
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '16px',
            borderBottom: '1px solid var(--surface-200)',
            backgroundColor: '#ffffff',
          }}
        >
          <div
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '12px',
              overflow: 'hidden',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            }}
          >
            <img
              src={Logo}
              alt="לימודים אקדמים"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </div>
          <span
            style={{
              fontFamily: "'Heebo', sans-serif",
              fontSize: '0.95rem',
              fontWeight: 500,
              position: 'relative',
              animation: 'shimmerRightToLeft 4s ease-in-out infinite',
              opacity: 0.9,
            }}
          >
            המרכז החרדי
          </span>
        </div>
        <div
          style={{
            flex: 1,
            overflow: 'auto',
            paddingRight: '16px',
            paddingLeft: '16px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              padding: '16px',
              backgroundColor: 'var(--surface-50)',
              marginBottom: '16px',
              borderRadius: '8px',
              boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
            }}
          >
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '4px',
                }}
              >
                <i
                  className="pi pi-building"
                  style={{
                    marginLeft: '8px',
                    color: 'var(--surface-700)',
                    fontSize: '0.9rem',
                  }}
                />
                <span
                  style={{
                    color: 'var(--surface-700)',
                    fontSize: '0.875rem',
                    fontWeight: 600,
                  }}
                >
                  שלוחה נוכחית
                </span>
              </div>
              <Dropdown
                value={globalConfigStore.rootFilter.currentBranches?.id}
                options={globalSettingsBranches.branches}
                onChange={(e) => handleBranchChange(e.value)}
                optionLabel="branchName"
                optionValue="id"
                placeholder="בחר שלוחה"
                className="branch-dropdown"
                style={{
                  width: '100%',
                  fontSize: '0.875rem',
                  backgroundColor: 'white',
                  border: '1px solid var(--surface-200)',
                  borderRadius: '6px',
                }}
              />
            </div>
            <div
              style={{
                height: '1px',
                backgroundColor: 'var(--surface-200)',
                margin: '4px 0',
              }}
            />
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '4px',
                }}
              >
                <i
                  className="pi pi-calendar"
                  style={{
                    marginLeft: '8px',
                    color: 'var(--surface-700)',
                    fontSize: '0.9rem',
                  }}
                />
                <span
                  style={{
                    color: 'var(--surface-700)',
                    fontSize: '0.875rem',
                    fontWeight: 600,
                  }}
                >
                  שנת לימודים נוכחית
                </span>
              </div>
              <Dropdown
                value={currentYear}
                options={years}
                onChange={(e) => handleYearChange(e.value)}
                placeholder="בחר שנה"
                className="year-dropdown"
                style={{
                  width: '100%',
                  fontSize: '0.875rem',
                  backgroundColor: 'white',
                  border: '1px solid var(--surface-200)',
                  borderRadius: '6px',
                }}
              />
            </div>
          </div>
          <div
            className="menu-item"
            onClick={createRipple}
            style={{
              height: '45px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Link
              to="/home"
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                width: '100%',
              }}
            >
              <i className="pi pi-home" style={{ marginLeft: '0.5rem' }}></i>
              <span>דף הבית</span>
            </Link>
          </div>

          <div
            className="menu-item"
            onClick={createRipple}
            style={{
              height: '45px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Link
              /*to="/reports/high-level"*/
              to="/"
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                width: '100%',
              }}
            >
              <i
                className="pi pi-chart-line"
                style={{ marginLeft: '0.5rem' }}
              ></i>
              <span>דף הבית - הנהלה</span>
            </Link>
          </div>

          <div style={{ height: '24px' }} />
          <ExpandableSection
            expanded={expanded2}
            setExpanded={setExpanded2}
            title="לימודים"
          >
            <div className="menu-items">
              {studiesItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.route}
                  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    width: '100%',
                  }}
                >
                  <div
                    className="menu-item"
                    data-category="education"
                    onClick={createRipple}
                    style={{
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      opacity: expanded2 ? '1' : '0',
                      transform: `translateX(${expanded2 ? '0' : '-10px'})`,
                      transitionDelay: `${index * 0.05}s`,
                    }}
                  >
                    <i
                      className={`pi ${item.icon}`}
                      style={{ marginLeft: '0.5rem' }}
                    ></i>
                    <span>{item.label}</span>
                  </div>
                </Link>
              ))}
            </div>
          </ExpandableSection>
          <div style={{ height: '24px' }} />
          <ExpandableSection
            expanded={expandedPayments}
            setExpanded={setExpandedPayments}
            title="תשלומים"
          >
            <div className="menu-items">
              {paymentItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.route}
                  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    width: '100%',
                  }}
                >
                  <div
                    className="menu-item"
                    data-category="finance"
                    onClick={createRipple}
                    style={{
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      opacity: expandedPayments ? '1' : '0',
                      transform: `translateX(${expandedPayments ? '0' : '-10px'})`,
                      transitionDelay: `${index * 0.05}s`,
                    }}
                  >
                    <i
                      className={`pi ${item.icon}`}
                      style={{ marginLeft: '0.5rem' }}
                    ></i>
                    <span>{item.label}</span>
                  </div>
                </Link>
              ))}
            </div>
          </ExpandableSection>
          <div style={{ height: '24px' }} />
          <ExpandableSection
            expanded={expandedUsers}
            setExpanded={setExpandedUsers}
            title="משתמשים"
          >
            <div className="menu-items">
              {usersItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.route}
                  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    width: '100%',
                  }}
                >
                  <div
                    className="menu-item"
                    onClick={createRipple}
                    style={{
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      opacity: expandedUsers ? '1' : '0',
                      transform: `translateX(${expandedUsers ? '0' : '-10px'})`,
                      transitionDelay: `${index * 0.05}s`,
                    }}
                  >
                    <i
                      className={`pi ${item.icon}`}
                      style={{ marginLeft: '0.5rem' }}
                    ></i>
                    <span>{item.label}</span>
                  </div>
                </Link>
              ))}
            </div>
          </ExpandableSection>
          <div style={{ height: '24px' }} />
          <ExpandableSection
            expanded={expandedAccounting}
            setExpanded={setExpandedAccounting}
            title="הנהלת חשבונות"
          >
            <div className="menu-items">
              {accountingItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.route}
                  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    width: '100%',
                  }}
                >
                  <div
                    className="menu-item"
                    data-category="accounting"
                    onClick={createRipple}
                    style={{
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      opacity: expandedAccounting ? '1' : '0',
                      transform: `translateX(${expandedAccounting ? '0' : '-10px'})`,
                      transitionDelay: `${index * 0.05}s`,
                    }}
                  >
                    <i
                      className={`pi ${item.icon}`}
                      style={{ marginLeft: '0.5rem' }}
                    ></i>
                    <span>{item.label}</span>
                  </div>
                </Link>
              ))}
            </div>
          </ExpandableSection>
          <div style={{ height: '24px' }} />
          <ExpandableSection
            expanded={expandedReports}
            setExpanded={setExpandedReports}
            title="דוחות"
          >
            <div className="menu-items">
              <ExpandableItem
                expanded={expandedStudiesReports}
                setExpanded={setExpandedStudiesReports}
                label="לימודים"
                icon="pi-book"
                items={studiesReportsItems}
                category="education"
              />
              <ExpandableItem
                expanded={expandedFinanceReports}
                setExpanded={setExpandedFinanceReports}
                label="פיננסים"
                icon="pi-money-bill"
                items={financeReportsItems}
                category="finance"
              />
              <ExpandableItem
                expanded={expandedAccountingReports}
                setExpanded={setExpandedAccountingReports}
                label="הנהלת חשבונות"
                icon="pi-wallet"
                items={accountingReportsItems}
                category="accounting"
              />
            </div>
          </ExpandableSection>
          <div style={{ height: '24px' }} />
          <ExpandableSection
            expanded={expandedSettings}
            setExpanded={setExpandedSettings}
            title="הגדרות"
          >
            <div className="menu-items">
              {settingsItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.route}
                  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    width: '100%',
                  }}
                >
                  <div
                    className="menu-item"
                    onClick={createRipple}
                    style={{
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      opacity: expandedSettings ? '1' : '0',
                      transform: `translateX(${expandedSettings ? '0' : '-10px'})`,
                      transitionDelay: `${index * 0.05}s`,
                    }}
                  >
                    <i
                      className={`pi ${item.icon}`}
                      style={{ marginLeft: '0.5rem' }}
                    ></i>
                    <span>{item.label}</span>
                  </div>
                </Link>
              ))}
            </div>
          </ExpandableSection>
          <div style={{ height: '24px' }} />
        </div>
        <SideBarUserProfile />
      </div>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Heebo:wght@400;500;700&display=swap');

          @keyframes shimmerRightToLeft {
            0% {
              color: var(--surface-600);
            }
            50% {
              color: var(--surface-500);
            }
            100% {
              color: var(--surface-600);
            }
          }
          /* Custom Scrollbar Styling */
          ::-webkit-scrollbar {
            width: 8px;
            background-color: transparent;
          }

          ::-webkit-scrollbar-thumb {
            background-color: var(--surface-300);
            border-radius: 4px;
          }

          ::-webkit-scrollbar-thumb:hover {
            background-color: var(--surface-400);
          }

          ::-webkit-scrollbar-track {
            background-color: transparent;
          }

          /* Hide scrollbar for Firefox */
          * {
            scrollbar-width: thin;
            scrollbar-color: var(--surface-300) transparent;
          }

          .expandable {
            width: 100%;
          }

          .expandable-header {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: none;
            border: none;
            cursor: pointer;
            font-size: 1rem;
            text-align: right;
          }

          .expandable-header:focus {
            outline: none;
          }

          .menu-items {
            padding: 0;
          }

          .menu-item {
            display: flex;
            align-items: center;
            padding: 0px 16px;
            cursor: pointer;
            transition: all 0.2s ease;
            position: relative;
            overflow: hidden;
            height: 45px;
            border-radius: 4px;
          }

          .menu-item.sub-item {
            padding-right: 8px;
            margin-right: 1.5rem;
            height: 45px;
            border-radius: 4px;
          }

          /* Education section (blue) */
          .menu-item[data-category="education"] {
            background-color: rgba(33, 150, 243, 0.03);
          }

          .menu-item[data-category="education"] i,
          .menu-item[data-category="education"] span {
            color: #1976d2;
          }

          .menu-item[data-category="education"]:hover {
            background-color: rgba(33, 150, 243, 0.1);
            box-shadow: 0 2px 4px rgba(33, 150, 243, 0.1);
          }

          .menu-item[data-category="education"]:hover i,
          .menu-item[data-category="education"]:hover span {
            color: #2196f3;
          }

          /* Finance section (green) */
          .menu-item[data-category="finance"] {
            background-color: rgba(76, 175, 80, 0.03);
          }

          .menu-item[data-category="finance"] i,
          .menu-item[data-category="finance"] span {
            color: #388e3c;
          }

          .menu-item[data-category="finance"]:hover {
            background-color: rgba(76, 175, 80, 0.1);
            box-shadow: 0 2px 4px rgba(76, 175, 80, 0.1);
          }

          .menu-item[data-category="finance"]:hover i,
          .menu-item[data-category="finance"]:hover span {
            color: #4caf50;
          }

          /* Accounting section (purple) */
          .menu-item[data-category="accounting"] {
            background-color: rgba(156, 39, 176, 0.03);
          }

          .menu-item[data-category="accounting"] i,
          .menu-item[data-category="accounting"] span {
            color: #7b1fa2;
          }

          .menu-item[data-category="accounting"]:hover {
            background-color: rgba(156, 39, 176, 0.1);
            box-shadow: 0 2px 4px rgba(156, 39, 176, 0.1);
          }

          .menu-item[data-category="accounting"]:hover i,
          .menu-item[data-category="accounting"]:hover span {
            color: #9c27b0;
          }

          /* Default hover for other items */
          .menu-item:hover {
            background-color: var(--surface-100);
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
            transform: translateY(-1px);
          }

          .menu-item:hover i,
          .menu-item:hover span {
            color: var(--surface-900);
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          }

          .menu-item i {
            transition: all 0.2s ease;
          }

          .menu-item span {
            transition: all 0.2s ease;
          }

          .menu-item::after {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(255, 255, 255, 0.2),
              transparent
            );
            transition: 0.5s;
          }

          .menu-item:hover::after {
            left: 100%;
          }

          .ripple {
            position: absolute;
            border-radius: 50%;
            transform: scale(0);
            animation: ripple 0.6s cubic-bezier(0.4, 0, 0.2, 1);
            background-color: rgba(0, 0, 0, 0.1);
            pointer-events: none;
          }

          @keyframes ripple {
            to {
              transform: scale(4);
              opacity: 0;
            }
          }

          .branch-dropdown .p-dropdown-label,
          .year-dropdown .p-dropdown-label {
            padding: 8px 12px;
            color: var(--surface-900);
          }

          .branch-dropdown .p-dropdown-trigger,
          .year-dropdown .p-dropdown-trigger {
            padding: 0 8px;
            color: var(--surface-600);
          }

          .branch-dropdown:hover,
          .year-dropdown:hover {
            border-color: var(--surface-400) !important;
          }

          .branch-dropdown:focus,
          .year-dropdown:focus {
            box-shadow: 0 0 0 2px var(--surface-100) !important;
            border-color: var(--surface-500) !important;
          }

          .branch-dropdown .p-dropdown-panel .p-dropdown-items .p-dropdown-item,
          .year-dropdown .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
            padding: 8px 12px;
            color: var(--surface-700);
            font-size: 0.875rem;
          }

          .branch-dropdown .p-dropdown-panel .p-dropdown-items .p-dropdown-item:hover,
          .year-dropdown .p-dropdown-panel .p-dropdown-items .p-dropdown-item:hover {
            background-color: var(--surface-50);
            color: var(--surface-900);
          }
        `}
      </style>
    </div>
  );
};

export default observer(SideBarAdministration);
